module.exports = __webpack_public_path__ + "img/inner-banner.a1d0ccbf.jpg";